import { clone } from '@jack-henry/frontend-utils/functions';
import { ChallengeSettingsModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../shared';

const nullCompanyAccountSettings: ChallengeSettingsModelDto = {
    id: 0,
    authenticationMethodId: 0,
    userStatusId: 0,
    symantecUserExists: false,
    userId: 0,
    tokenCredentialState: 0,
};

export enum AuthenticationMethodType {
    Disabled = 0,
    Oob = 1,
    SecureToken = 2,
}
export enum UserStatusType {
    Unregistered = 0,
    Registered = 1,
    Suspended = 2,
    Locked = 3,
}

export enum VerificationMethodType {
    Text = 'sms',
    Phone = 'phone',
}

export class CompanyUserChallengeDetails extends DomainEntity<ChallengeSettingsModelDto> {
    constructor(dto = clone(nullCompanyAccountSettings)) {
        super(dto);
    }

    public createDefault(): this {
        return new CompanyUserChallengeDetails(clone(nullCompanyAccountSettings)) as this;
    }

    public get authMethod() {
        return this.dto.authenticationMethodId as AuthenticationMethodType;
    }

    public get verificationMethodType() {
        return (
            (this.dto.oobVerificationMethodType?.toLowerCase() as VerificationMethodType) ||
            undefined
        );
    }

    public set verificationMethodType(value: VerificationMethodType) {
        this.dto.oobVerificationMethodType = value;
    }

    public get userStatus() {
        return this.dto.userStatusId as UserStatusType;
    }

    public get symantecUserExists() {
        return this.dto.symantecUserExists;
    }

    public get isOobPinCollected() {
        if (this.authMethod !== AuthenticationMethodType.Oob) {
            return false;
        }
        return this.dto.isOobPinCollected;
    }

    public get tokenCredentialState() {
        return this.dto.tokenCredentialState;
    }

    public get secureTokenUserId() {
        return this.dto.tokenUserId;
    }

    public get utcSuspendEndTime() {
        return this.dto.utcSuspendEndTime;
    }

    public get localSuspendEndTime() {
        return this.dto.localSuspendEndTime;
    }

    public get isSuspended() {
        const endTime = this.utcSuspendEndTime;
        if (!endTime) {
            return false;
        }
        const suspendTime = endTime.endsWith('Z') ? endTime : `${endTime}Z`;
        return new Date(suspendTime).getTime() > Date.now();
    }
}
